import styled, { css, keyframes } from "styled-components";
import { lighten } from "polished";
import { IMessageDisplayStyleProps } from "./interfaces";


const FadeIn = keyframes`
    0% {
        opacity: 0;
    }
    20% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

export const StyledMessageDisplay = styled.div<IMessageDisplayStyleProps>`
    position: absolute;
    top: 12px;
    left: 200px;
    right: 200px;
    text-align: center;
    color: ${p => p.isChristmas ? p.theme.c.whiteOnActive : p.theme.c.dark};
    font-size: 30px;
    ${p =>
        p.isLow &&
        css`
            top: 42px;
        `}
    animation: ${FadeIn} 1000ms;
    ${({ isChristmas, type, theme: { c } }) => isChristmas && css`
        > span {
            background-color: ${type === "completed" ? c.correct : c.incorrect};
            padding: 2px 12px 8px 0px;
            transform: translateY(-10px);
            display: inline-block;
        }
        .i-check,
        .i-times {
            color: ${c.white} !important;
        }
    `}
`;

export const Check = styled.span`
    color: ${p => p.theme.c.correct};
    .i-check,
    .i-times {
        position: relative;
        font-size: 52px;
        display: inline-block;
        margin: -10px 6px;
        top: 11px;
    }
`;

export const Times = styled(Check)`
    color: ${p => p.theme.c.incorrect};
`;

export const NextTaskWrapper = styled.div`
    button {
        bottom: -12px;
        left: calc(100% + 16px);
    }
`;